export type TutorialAccent = 'teal' | 'green' | 'purple';

export type TutorialGuide = {
  id: string;
  number: number;
  title: string;
  subtitle: string;
  description: string;
  audience: string;
  pages: number;
  fileName: string;
  accent: TutorialAccent;
};

export const TUTORIAL_GUIDES: TutorialGuide[] = [
  {
    id: 'sala',
    number: 1,
    title: 'Acesso e Uso da Sala',
    subtitle: 'Para todos os consteladores',
    description:
      'Como entrar no consultório virtual, escolher avatar, usar cada controle da sala, compartilhar o link, aprovar participantes e conduzir a sessão.',
    audience: 'Todos',
    pages: 33,
    fileName: 'guia-1-acesso-e-uso-da-sala.pdf',
    accent: 'teal',
  },
  {
    id: 'avulsas',
    number: 2,
    title: 'Configuração: Horas Avulsas',
    subtitle: 'Quem contrata horas ou pacotes',
    description:
      'Acompanhe créditos, histórico de uso e assinaturas no Painel. Ideal para quem usa horas avulsas sem plano de Associado.',
    audience: 'Horas avulsas',
    pages: 7,
    fileName: 'guia-2-configuracao-horas-avulsas.pdf',
    accent: 'green',
  },
  {
    id: 'associados',
    number: 3,
    title: 'Configuração: Associados',
    subtitle: 'Plano de assinatura',
    description:
      'Perfil na vitrine, Google Agenda, horários de trabalho, agendamentos e repasse financeiro via PIX.',
    audience: 'Associados',
    pages: 9,
    fileName: 'guia-3-configuracao-associados.pdf',
    accent: 'purple',
  },
];

export const CONSTELADOR_CLUB_WHATSAPP_URL = "https://chat.whatsapp.com/DsJxwW1i4IJ6pernEwmtQC";

export function getTutorialDownloadUrl(fileName: string): string {
  return `/tutoriais/${fileName}`;
}

/** Vídeo tutorial da sala (YouTube) — mesmo do e-mail de boas-vindas aos consteladores. */
export const TUTORIAL_FEATURED_VIDEO = {
  youtubeVideoId: '15N-johuIVE',
  title: 'Acesso e Uso da Sala',
  description:
    'Aprenda a entrar na sala virtual, usar avatares, controles, chat e conduzir a sessão, passo a passo em vídeo.',
  watchLabel: 'Assistir ao vídeo tutorial da sala',
} as const;

export function getTutorialVideoEmbedUrl(videoId: string): string {
  return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&playsinline=1`;
}

export function getTutorialVideoWatchUrl(videoId: string): string {
  return `https://www.youtube.com/watch?v=${videoId}`;
}
